export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_NL_RGB_blk_100317.6da3d25b.svg";